import React, { useEffect, useMemo, useState } from 'react';
import PartialTable from 'components/partials/PartialTable';
import './WpoDashboard.css';
import PropTypes from 'prop-types';
import { statusOptions } from './WpoDashboardType';
import moment from 'moment';
import { Button, Col, Row } from 'react-bootstrap';
import { exportExcel } from 'services/stock-location/wpoDashboardService';
import { useSortBe } from 'hooks/useBeHandle';
const formatCurrency = value =>
  new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: 'GBP',
    minimumFractionDigits: 2
  }).format(Number(value || 0));

function WpoDashboardTable({
  data,
  exportParam,
  paging,
  total,
  nextPage,
  previousPage,
  gotoPage,
  onPageSizeChange,
  colSort,
  handleSort,
  openGRNsModal,
  openBookingInModal
}) {
  const originColumns = useMemo(
    () => [
      {
        accessor: 'bookIn',
        Header: 'Book In',
        disableSortBy: true,
        Cell: rowData => {
          const row = rowData.row.original;
          return (
            <button
              type="button"
              className="btn btn-link btn-sm p-0 fw-bold border-0"
              onClick={() => openBookingInModal(row)}
            >
              BOOK IN
            </button>
          );
        }

      },
      {
        accessor: 'wpoNo',
        Header: 'WPO'
      },
      {
        accessor: 'supplier',
        Header: 'Supplier'
      },
      {
        accessor: 'data',
        Header: 'Value',
        Cell: rowData => formatCurrency(rowData.row.original.data)
      },
      {
        accessor: 'orderedDate',
        Header: 'Ordered',
        Cell: rowData =>
          moment(rowData.row.original.orderedDate).format('DD/MM/YYYY')
      },
      {
        accessor: 'dueDate',
        Header: 'Due',
        Cell: rowData => {
          const date = moment(rowData.row.original.dueDate);
          return date.isValid() ? date.format('DD/MM/YYYY') : 'Not received';
        }
      },
      {
        accessor: 'receivedDate',
        Header: 'Received',
        Cell: rowData => {
          const date = moment(rowData.row.original.receivedDate);
          return date.isValid() ? date.format('DD/MM/YYYY') : 'Not received';
        }
      },
      {
        accessor: 'status',
        Header: 'Status',
        Cell: rowData => {
          const status = rowData.row.original.status;
          return statusOptions.find(x => x.value === status)?.label || status;
        }
      },
      {
        accessor: 'grnsCount',
        Header: 'GRNs',
        Cell: rowData => {
          const { grnCount, wpoNo  } = rowData.row.original;
          return (
            <button
              type="button"
              className="btn btn-link btn-sm p-0"
              onClick={() => openGRNsModal(wpoNo)}
            >
              {grnCount ?? 0}
            </button>
          );
        }
      }
    ],
    []
  );
  const handleCopy = async () => {
    try {
      if (!data?.length) return;

      const header = [
        'WPO',
        'Supplier',
        'Value',
        'Ordered',
        'Due',
        'Received',
        'Status',
        'GRNs'
      ];

      const rows = data.map(x => [
        String(x.wpoNo ?? ''),
        String(x.supplier ?? ''),
        String(formatCurrency(x.data) ?? ''),
        String(
          x.orderedDate ? moment(x.orderedDate).format('DD MMM YYYY') : ''
        ),
        String(x.dueDate ? moment(x.dueDate).format('DD MMM YYYY') : ''),
        String(
          x.receivedDate ? moment(x.receivedDate).format('DD MMM YYYY') : ''
        ),
        String(
          statusOptions.find(s => s.value === x.status)?.label || x.status || ''
        ),
        String(x.grnCount ?? '')
      ]);

      const text = [header, ...rows]
        .map(row => row.map(cell => `"${cell}"`).join('\t'))
        .join('\n');

      await navigator.clipboard.writeText(text);

      alert(`Copied ${rows.length} rows`);
    } catch (err) {
      console.error('Copy error', err);
    }
  };
  const [columns, setColumns] = useState([]);

  const { reNewColumns } = useSortBe(
    originColumns,
    colSort,
    setColumns,
    columns
  );

  useEffect(() => {
    reNewColumns();
  }, [colSort]);
  return (
    <>
      {data?.length > 0 && (
        <Row className="mb-2 g-2">
          <Col xs="auto">
            <Button
              variant="outline-primary"
              onClick={async () => {
                try {
                  const res = await exportExcel(exportParam);

                  const url = URL.createObjectURL(res.data);

                  const a = document.createElement('a');
                  a.href = url;
                  a.download = 'WPO_Dashboard.xlsx';
                  a.click();

                  URL.revokeObjectURL(url);
                } catch (err) {
                  console.error('Export error', err);
                }
              }}
            >
              Excel
            </Button>
          </Col>
          <Col xs="auto">
            <Button variant="outline-secondary" onClick={handleCopy}>
              Copy
            </Button>
          </Col>
        </Row>
      )}
      <PartialTable
        data={data}
        columns={columns}
        paging={paging}
        total={total}
        nextPage={nextPage}
        previousPage={previousPage}
        gotoPage={gotoPage}
        onPageSizeChange={onPageSizeChange}
        beSortOption={{ canSort: true, handleSort: handleSort }}
        handleClickRow={() => {}}
      />
    </>
  );
}

WpoDashboardTable.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  paging: PropTypes.object,
  total: PropTypes.number,
  nextPage: PropTypes.func,
  previousPage: PropTypes.func,
  gotoPage: PropTypes.func,
  onPageSizeChange: PropTypes.func,
  handleInputChange: PropTypes.func,
  exportParam: PropTypes.object,
  colSort: PropTypes.object,
  handleSort: PropTypes.func,
  openGRNsModal: PropTypes.func,
  openBookingInModal: PropTypes.func
};


export default WpoDashboardTable;
